import operadora from './operadora';

export default {
    namespaced: true,
    modules: {
        operadora
    },
};